import SupportingEachotherTwoFr from "components/hero/supporting-eachother-2-fr";
import { Underline } from "components/type";
import * as React from 'react';
export default {
  SupportingEachotherTwoFr,
  Underline,
  React
};